import removed from '@mailobj-browser/front/js/tree/removed.js'

const elementsMap = new Map()

export const add = (
  node,
  className,
  target = node.ownerDocument.body
) => {
  if (!elementsMap.has(className)) {
    elementsMap.set(className, new Map())
  }

  const elements = elementsMap.get(className)

  if (!elements.has(target)) {
    elements.set(target, new Set())
  }

  const nodes = elements.get(target)

  if (!nodes.has(node)) {
    nodes.add(node)
    target.classList.add(className)

    queueMicrotask(async () => {
      await Promise.race([removed(node), removed(target)])
      remove(node, className, target)
    })
  }
}

export const remove = (
  node,
  className,
  target = node.ownerDocument.body
) => {
  const elements = elementsMap.get(className)
  const nodes = elements?.get(target)

  if (nodes?.has(node)) {
    nodes.delete(node)

    if (!nodes.size) {
      elements.delete(target)

      if (!elements.size) {
        target.classList.remove(className)
        elementsMap.delete(className)
      }
    }
  }
}
